import { isPurchaseCreditsRow } from './ledgerUtils';
function str(v) {
    return v != null ? String(v).trim() : '';
}
function parseMeta(row) {
    return row.metadata && typeof row.metadata === 'object' ? row.metadata : {};
}
function resolveWalletOwnerType(row) {
    var _a, _b;
    const rec = row;
    const wallet = ((_a = rec.usdWallet) !== null && _a !== void 0 ? _a : rec.usd_wallet);
    return str((_b = wallet === null || wallet === void 0 ? void 0 : wallet.ownerType) !== null && _b !== void 0 ? _b : wallet === null || wallet === void 0 ? void 0 : wallet.owner_type).toLowerCase();
}
function rolePrefix(ownerType) {
    switch (ownerType) {
        case 'shop':
            return 'Shop';
        case 'agent':
            return 'Agent';
        case 'super_agent':
            return 'Super agent';
        case 'player':
            return 'Player';
        default:
            return 'Account';
    }
}
/** Player deposit credited to a tier wallet (player has no USD wallet). */
export function isPlayerAttributedDeposit(row) {
    var _a, _b;
    const type = str(row.type).toLowerCase();
    if (type !== 'deposit')
        return false;
    const meta = parseMeta(row);
    if (str((_a = meta.playerId) !== null && _a !== void 0 ? _a : meta.player_id))
        return true;
    const txnId = str((_b = row.transactionId) !== null && _b !== void 0 ? _b : row.transaction_id);
    if (/:player:/i.test(txnId))
        return true;
    const source = str(meta.source).toLowerCase();
    if (source.includes('creditplayermainwallet'))
        return true;
    const note = str(meta.note).toLowerCase();
    if (note.includes('player has no usd_wallet'))
        return true;
    return false;
}
/** Tier wallet debited to pay out a player withdrawal. */
export function isPlayerPayoutWithdrawal(row) {
    var _a, _b, _c;
    const type = str(row.type).toLowerCase();
    if (type !== 'withdrawal')
        return false;
    const txnId = str((_a = row.transactionId) !== null && _a !== void 0 ? _a : row.transaction_id);
    if (txnId.includes('player_payout'))
        return true;
    const meta = parseMeta(row);
    if (str(meta.source) === 'playerPayoutTierSettlementBizService')
        return true;
    const ref = str((_b = row.referenceType) !== null && _b !== void 0 ? _b : row.reference_type).toLowerCase();
    if (str((_c = meta.playerId) !== null && _c !== void 0 ? _c : meta.player_id) && ref === 'payment_transaction')
        return true;
    return false;
}
/** Portal online-balance withdrawal requested by shop/agent/super agent. */
export function isPortalTierWithdrawal(row) {
    var _a, _b;
    const type = str(row.type).toLowerCase();
    if (type !== 'withdrawal')
        return false;
    const ref = str((_a = row.referenceType) !== null && _a !== void 0 ? _a : row.reference_type).toLowerCase();
    if (ref === 'usd_withdrawal_request')
        return true;
    const txnId = str((_b = row.transactionId) !== null && _b !== void 0 ? _b : row.transaction_id);
    if (txnId.startsWith('usd_withdrawal_request:'))
        return true;
    const createdBy = str(parseMeta(row).createdBy).toLowerCase();
    if (createdBy.endsWith('_portal'))
        return true;
    return false;
}
/**
 * Human-readable activity for USD ledger rows (who initiated / what happened).
 */
export function usdLedgerActivityLabel(row) {
    const ownerType = resolveWalletOwnerType(row);
    const role = rolePrefix(ownerType);
    const type = str(row.type).toLowerCase();
    if (isPurchaseCreditsRow(row)) {
        return `${role} purchase credits`;
    }
    if (type === 'deposit') {
        if (isPlayerAttributedDeposit(row))
            return 'Player deposit';
        return `${role} deposit`;
    }
    if (type === 'withdrawal') {
        if (isPlayerPayoutWithdrawal(row))
            return 'Player withdrawal';
        if (isPortalTierWithdrawal(row))
            return `${role} withdrawal`;
        return `${role} withdrawal`;
    }
    const displayLabel = str(row.displayLabel);
    if (displayLabel)
        return displayLabel;
    if (type === 'adjustment') {
        return `${role} balance correction`;
    }
    if (type === 'reversal') {
        return `${role} reversal`;
    }
    return '—';
}
